import { UpsertableBase } from "./UpsertableBase";

export interface DisablableOption {
  id: string;
  text: string;
  detail?: string;
  value_text?: string;
  image_url?: string;
  disabled?: boolean;
  reason?: string;
  hidden1?: string;
  hidden2?: string;
  hidden_num1?: number;
  hidden_num2?: number;
}

export const toDisablableOption = ({
  obj, 
  formatName,
  detail,
  use_field,
  disable
}: {
  obj: string | DisablableOption | UpsertableBase, 
  formatName?: (obj: UpsertableBase) => string,
  detail?: (obj: UpsertableBase) => string,
  use_field?: string,
  disable?: (obj: UpsertableBase) => boolean,
}): DisablableOption => {
  if (typeof obj === "string") {
    const opt: DisablableOption = {
      id: obj, text: obj
    };
    return opt;
  } else if (obj instanceof UpsertableBase) {
    const opt: DisablableOption = {
      id: obj._id, 
      text: formatName ? formatName(obj) : obj.name, 
      detail: detail ? detail(obj) : undefined,
      disabled: disable ? disable(obj) : false
    };
    if (use_field) {
      const obj_as_any = obj as any;
      if (obj_as_any[use_field] !== undefined) {
        opt.id = use_field;
      }
    }
    return opt;
  } else {
    return obj;
  }
}
